import { useEffect } from "react";
import PropTypes from "prop-types";
import ReactGA from "react-ga4";

import { Link } from "react-router-dom";

import T from "../translations/Translations";

const StudentSelect = ({ studentsIc }) => {
    const studentSelectInstructions = T({ key: "Student_Select_Instructions" });

    /**
     * send a pageview for selecting a student
     */
    useEffect(() => {
        const page =
            process.env.NODE_ENV !== "production" ? "/guardian/student-select -> dev" : "/guardian/student-select";
        ReactGA.send({
            hitType: "pageview",
            page,
            title: document.title
        });
    }, []);

    if (!studentsIc) {
        return null;
    }

    return (
        <div className="guardian-student-select">
            <div className="guardian-select-title">{studentSelectInstructions}:</div>
            {studentsIc &&
                studentsIc.map((student) => {
                    return (
                        <div className="guardian-student-link" key={student.studentNumber}>
                            <Link to={`/guardian/archive/${student.studentNumber}`}>
                                {student.firstName} {student.lastName}
                            </Link>
                        </div>
                    );
                })}
        </div>
    );
};

StudentSelect.propTypes = {
    studentsIc: PropTypes.instanceOf(Array)
};

StudentSelect.defaultProps = {
    studentsIc: null
};

export default StudentSelect;
